import React  from 'react';
const value = {
  path:"fthbi",
  title:"First Time Home-Buyer Incentive",
  date_modified:"Oct 2019",
  date_created:"Oct 2019",
  content:
[
<p align="justify">
  As of September 2, 2019, the government of Canada is offering first-time homebuyers the opportunity to purchase a home in tandem with the government. If applicants qualify as a first-time buyer, have an income less than $120,000, and already have at least a 5% down-payment, the government will supply either 10% or 5% more toward the down-payment, in exchange for an equivalent amount of ownership in the property. This government loan is interest free, and does not need to be paid back in a hurry. By increasing their down-payment, the buyer saves money on interest (because of a smaller mortgage), and lowers the burden of their mortgage payments by hundreds of dollars each month.
</p>
,
<p align="justify">
  To qualify as a first-time buyer, one of the following must be true:
</p>
,
<ul>
  <li>You have never purchased a home before.</li>
  <li>You have gone through a divorce, or separation from a common-law partner.</li>
  <li>In the last 4 years, you did not live in a house owned by you or your current partner.</li>
</ul>
,

<p align="justify">
  It should also be noted that only one borrower needs to meet these requirements for your application to be considered.
</p>
,
<p align="justify">
  The size of the incentive you qualify for depends on the type of house you are purchasing. New houses qualify for either a 5% or 10% incentive, existing houses qualify for a 5% incentive, and mobile homes - of any age - qualify for a 5% incentive. The building you are purchasing must also be used, by you, as a residence; investment properties do not qualify. The program also limits the amount that can be borrowed for mortgages; any house that requires a mortgage greater than 4x the qualifying income is not eligible for the program.
</p>
,
<p align="justify">
  The homebuyer will be required to pay the government back within 25 years, or, when they sell the house - whichever happens first. Because this is a shared equity deal, the buyer will not necessarily be paying back the same amount that was initially borrowed; they will be required to pay back the same percent of the house’s value. This means the government will share in the loss, or gain, of the value of the house. For example:
</p>
,
<ul>
  <li>Bob wants to purchase a $350,000 house, and applies to the FTHBI program.</li>
  <li>Bob qualifies as a first-time homebuyer; he is granted an incentive of 5%.</li>
  <li>The government adds an additional $17,500 to Bob’s downpayment, and takes ownership of 5% of the house.</li>
  <li>2 years later, Bob decides to perform $15,000 worth of renovations to his house.</li>
  <li>10 years after he bought the house, Bob has decided he wants to move to a bigger house, and decides to sell the house he bought using the FTHBI.</li>
  <li>Because the government wants it’s fair share, Bob must have the house appraised. The appraiser finds the house is now worth $25,000 more than what Bob paid for it - a $15,000 increase from renovations and a $10,000 increase from market appreciation.</li>
  <li>Because the government owns 5% of the house, Bob must repay $18,750, which is $1,250 more than what he was loaned.</li>
</ul>
,
<p align="justify">
  The FTHBI may seem like a win-win, but the program has its downsides, as well. As the buyer, you will always save on mortgage payments by having a larger down-payment, but you could end up with less in your pocket in the long run. Remember, you will likely not pay back the same amount you borrowed. If the house appreciates in value so much that the difference between the paid-back amount and the initial investment is greater than the mortgage savings, you would have been better off not taking the incentive. So, if you think the house might appreciate quickly, and you are able to afford higher mortgage payments, you may want to avoid the FTHBI.
</p>
],
  tags:["down-payment","government program"]
}

  export default value



// WEBPACK FOOTER //
// src/content/fthbi.js